var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticStyle:{"text-align":"center"}},[_vm._v("Option Management")]),_c('v-card',{staticClass:"text-xs-center"},[_c('OptionTable')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }